<template>
  <div class="list">
    <div class="breadcrumb">
      <Breadcrumb>
        <Breadcrumb-item href="#">代理管理</Breadcrumb-item>
        <Breadcrumb-item>代理用户</Breadcrumb-item>
      </Breadcrumb>
    </div>
    <div class="search" @keyup.enter="search">
      <Form :label-width="60" :show-message="false">
        <Row :gutter="12">
          <Col :xs="12" :sm="8" :md="6">
            <Form-item label="学生ID" >
                <Input name="uid"
                  v-model="queryParam.uid"></Input>
            </Form-item>
          </Col>
          <Col :xs="12" :sm="8" :md="6">
            <Form-item  :label-width="75" label="学生手机号">
                <Input placeholder="支持模糊搜索" name="userMobile"
                  v-model="queryParam.userMobile"></Input>
            </Form-item>
          </Col>
          <Col :xs="12" :sm="8" :md="6">
            <Form-item label="学生姓名" :label-width="75">
                <Input placeholder="支持模糊搜索" name="userNickname"
                  v-model="queryParam.userNickname"></Input>
            </Form-item>
          </Col>
          <Col :xs="12" :sm="8" :md="4">
            <Button type="primary" :loading="searchLoading" :disable="searchLoading" icon="search"
              @click="search" >搜索</Button>
          </Col>
        </Row>
      </Form>
    </div>
    <List ref="dataList" :tableColumns="title" :reload="reload" listUrl="/agentUser/list"
      :params="queryParam" :onLoading="onLoading" operator=""></List>
  </div>

</template>
<script>
  export default {
    data () {
      let $moment = this.$moment
      return {
        searchLoading: false,
        reload: 0,
        queryParam: {
          uid: '',
          userMobile: '',
          userNickname: ''
        },
        title: [
          {
            title: '用户ID、昵称',
            render: (h, params) => {
              let row = params.row
              return h('div', [
                h('span', row.uid),
                h('span', { style: { color: 'gray' } }, ' - '),
                h('a', { on: { 
                  click: () => { 
                    this.$router.push({ path: '/agent/agentInviteList', query: {inviteId: row.uid} }) 
                  } 
                } }, (row.userNickname || ''))
              ])
            }
          },
          {
            title: '手机号',
            key: 'userMobile'
          },
          {
            title: '创建时间',
            align: 'center',
            render: (h, params) => {
              let createTime = params.row.createTime
              return h('span', createTime && $moment(createTime, 'X').format('YYYY-MM-DD HH:mm:ss'))
            }
          },
        ]
      }
    },
    mounted: function () {
    },
    created: function () {
    },
    methods: {
      search () {
        this.reload = new Date().getTime()
      },
      onLoading (loading) {
        this.searchLoading = loading
      }
    }
  }

</script>



// WEBPACK FOOTER //
// AgentUserList.vue?79bf8fa6